var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDropdownOld({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8966_829426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.651057 2.64684C0.651057 2.39554 0.749363 2.15987 0.928404 1.98278C1.10614 1.80764 1.34116 1.71195 1.59051 1.7139C1.83986 1.71584 2.07358 1.81416 2.24806 1.99124L4.59962 4.3721L6.93164 2.01076C7.10678 1.83368 7.3405 1.73472 7.58984 1.73342C7.83919 1.73147 8.07422 1.82716 8.2513 2.0023C8.43034 2.17938 8.5293 2.41506 8.5293 2.66702C8.5293 2.91376 8.43359 3.14683 8.25976 3.32262L5.26367 6.35582C5.07747 6.53942 4.84244 6.63511 4.5931 6.63316C4.34375 6.63122 4.11003 6.5329 3.93555 6.35582L0.919924 3.30308C0.74675 3.1273 0.651057 2.89424 0.651057 2.64684Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8966_829426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8.59961) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDropdownOld);
export default __webpack_public_path__ + "static/media/chevron-dropdown-old.6bc9536e4d9900d0c95166d81dbd7004.svg";
export { ForwardRef as ReactComponent };